import { useQueryClient } from '@tanstack/vue-query'
import type { Elemental } from '~~/src/types/elemental'

export const useTemplateElemental = () => {
  const queryClient = useQueryClient()

  const invalidateTemplateQueries = async (elemental: Elemental) => {
    await queryClient.invalidateQueries({ queryKey: ['profile-list-elementals', elemental.elementalTypeId] })
    await queryClient.invalidateQueries({ queryKey: ['elemental', elemental.elementalTypeId] })
    await queryClient.invalidateQueries({ queryKey: ['elementals-infinity', { is_template: true }] })
  }

  return {
    invalidateTemplateQueries,
  }
}
